// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import UserOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/UserOutlined';
import UnlockOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/UnlockOutlined';
import SnippetsOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/SnippetsOutlined';
import FileOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/FileOutlined';
import PictureOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/PictureOutlined';
import AudioOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/AudioOutlined';
export default { SmileOutlined, CrownOutlined, UserOutlined, UnlockOutlined, SnippetsOutlined, FileOutlined, PictureOutlined, AudioOutlined };
